import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const fundTransactionTypeEnum = createEnum({
    PAYMENT: ['payment', '付款', 'blue'],
    RECEIPT: ['receipt', '收款', 'green'],
    REFUND: ['refund', '退款', 'orange'],
    MANUAL_ACCOUNT_ADJUSTMENT: [
        'manual_account_adjustment',
        '手工调账',
        'purple',
    ],
});
export const FUND_TRANSACTION_TYPES = enumValues(fundTransactionTypeEnum);
export const FUND_TRANSACTION_TYPE_LABEL_MAP = enumLabelMap(fundTransactionTypeEnum);
export const fundTransactionDirectionEnum = createEnum({
    IN: ['in', '收入', 'green'],
    OUT: ['out', '支出', 'orange'],
});
export const FUND_TRANSACTION_DIRECTIONS = enumValues(fundTransactionDirectionEnum);
export const FUND_TRANSACTION_DIRECTION_LABEL_MAP = enumLabelMap(fundTransactionDirectionEnum);
export const fundTransactionCategoryEnum = createEnum({
    DOWN_PAYMENT: ['down_payment', '首付款', 'blue'],
    FINAL_PAYMENT: ['final_payment', '尾款', 'purple'],
    FULL_PAYMENT: ['full_payment', '全款', 'cyan'],
    DEPOSIT: ['deposit', '定金', 'gold'],
    OTHER: ['other', '其他', 'default'],
});
export const FUND_TRANSACTION_CATEGORIES = enumValues(fundTransactionCategoryEnum);
export const FUND_TRANSACTION_CATEGORY_LABEL_MAP = enumLabelMap(fundTransactionCategoryEnum);
export const fundTransactionStatusEnum = createEnum({
    DRAFT: ['draft', '草稿', 'default'],
    REVIEWING: ['reviewing', '审核中', 'processing'],
    REVIEW_REJECTED: ['review_rejected', '审核拒绝', 'red'],
    PENDING_PAYMENT: ['pending_payment', '待付款', 'orange'],
    PAYMENT_REJECTED: ['payment_rejected', '付款驳回', 'red'],
    PARTIAL_PAID: ['partial_paid', '部分付款', 'blue'],
    FULLY_PAID: ['fully_paid', '全部付款', 'cyan'],
    PENDING_RECEIPT: ['pending_receipt', '待回款', 'orange'],
    RECEIPT_REJECTED: ['receipt_rejected', '回款驳回', 'red'],
    PARTIAL_RECEIVED: ['partial_received', '部分回款', 'blue'],
    FULLY_RECEIVED: ['fully_received', '全部回款', 'cyan'],
});
export const FUND_TRANSACTION_STATUSES = enumValues(fundTransactionStatusEnum);
export const FUND_TRANSACTION_STATUS_LABEL_MAP = enumLabelMap(fundTransactionStatusEnum);
export const fundTransactionPaymentStatusEnum = createEnum({
    DRAFT: ['draft', '草稿', 'default'],
    REVIEWING: ['reviewing', '审核中', 'processing'],
    REVIEW_REJECTED: ['review_rejected', '审核拒绝', 'red'],
    PENDING_PAYMENT: ['pending_payment', '待付款', 'orange'],
    PAYMENT_REJECTED: ['payment_rejected', '付款驳回', 'red'],
    PARTIAL_PAID: ['partial_paid', '部分付款', 'blue'],
    FULLY_PAID: ['fully_paid', '全部付款', 'cyan'],
});
export const FUND_TRANSACTION_PAYMENT_STATUSES = enumValues(fundTransactionPaymentStatusEnum);
export const FUND_TRANSACTION_PAYMENT_STATUS_LABEL_MAP = enumLabelMap(fundTransactionPaymentStatusEnum);
export const fundTransactionReceiptStatusEnum = createEnum({
    DRAFT: ['draft', '草稿', 'default'],
    REVIEWING: ['reviewing', '审核中', 'processing'],
    REVIEW_REJECTED: ['review_rejected', '审核拒绝', 'red'],
    PENDING_RECEIPT: ['pending_receipt', '待回款', 'orange'],
    RECEIPT_REJECTED: ['receipt_rejected', '回款驳回', 'red'],
    PARTIAL_RECEIVED: ['partial_received', '部分回款', 'blue'],
    FULLY_RECEIVED: ['fully_received', '全部回款', 'cyan'],
});
export const FUND_TRANSACTION_RECEIPT_STATUSES = enumValues(fundTransactionReceiptStatusEnum);
export const FUND_TRANSACTION_RECEIPT_STATUS_LABEL_MAP = enumLabelMap(fundTransactionReceiptStatusEnum);
export const EDITABLE_FUND_TRANSACTION_STATUSES = [
    fundTransactionStatusEnum.DRAFT,
    fundTransactionStatusEnum.REVIEW_REJECTED,
    fundTransactionStatusEnum.PAYMENT_REJECTED,
    fundTransactionStatusEnum.RECEIPT_REJECTED,
];
//# sourceMappingURL=fund-transaction.js.map